<template>
  <el-container class="w-full h-full bg-gray-50">
    <el-header class="flex justify-between shadow	bg-white">
      <div></div>
      <User/>
    </el-header>
    <el-main class="m-0 p-0 flex">
      <div class="layout-menus w-28 h-full flex justify-center pt-16">
        <div class="fixed ">
          <Menus :collapse="true"/>
        </div>

      </div>
      <div class="layout-body flex-1 border-gray-500 h-full flex flex-col">
        <div class="layout-title h-16 items-center flex">
          在线考试
        </div>
        <div class="layout-content flex-1 h-full pb-12 pr-8 box-border">
          <div class="shadow-2xl rounded-xl overflow-hidden layout-row bg-white">
            <el-scrollbar class="h-full">
              <router-view></router-view>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import Menus from "./components/Menus";
import User from "./components/User";

export default {
  name: "AdminLayout",
  /**
   * 调用组建
   * @type {Object}
   */
  components: {Menus, User},
  /**
   * 组建属性
   * @type {Object}
   */
  props: {},
  /**
   * 数据字段
   * @return {[type]} [description]
   */
  data() {
    return {};
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {},
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面创建时
   * @return {[type]} [description]
   */
  created() {

  },
  /**
   * 页面加载时
   * @return {[type]} [description]
   */
  mounted() {

  },
  /**
   * 页面调用函数
   * @type {Object}
   */
  methods: {}
};
</script>
<style lang="scss">
.logo {
  width: 124px;
  height: 40px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 100%;
  }

}

.admin-menus {
  width: 64px;
}

.layout-row {
  height: calc(100vh - 60px - 7em);
  width: calc(100vw - 9em);
}
</style>
